<h1 mat-dialog-title class="col-12 update-passwordTitle">{{data.dialogTitle}}</h1>


<mat-form-field class="col-12">
  <input matInput [(ngModel)]="currentPassword" placeholder="Current Password" type="password" autocomplete="off">
</mat-form-field>

<mat-form-field class="col-12">
  <input matInput [(ngModel)]="newPassword" placeholder="New Password" type="password" autocomplete="off">
</mat-form-field>


<mat-form-field class="col-12">
  <input matInput [(ngModel)]="confirmPassword" placeholder="Confirm Password" type="password" autocomplete="off">
</mat-form-field>

<div class="col-12 mb-3">
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onClickCancel()" class="update-passwordCancelButton">Cancel</button>
    <button mat-raised-button color="primary" (click)="onClickSave()" cdkFocusInitial class="update-passwordSaveButton">Save</button>
  </mat-dialog-actions>
</div>
